import dynaForms from '@elab/core/utils/dynaForms';

const getTypes = storeName => ({
    ...dynaForms.getTypes(storeName),
    CLOSE_AND_LOGOUT: `${storeName}.CLOSE_AND_LOGOUT`,
    INTERRUPT_LOGIN: `${storeName}.INTERRUPT_LOGIN`,
    PHONE_NUMBER_UPDATED: `${storeName}.PHONE_NUMBER_UPDATED`,
    IS_CHECKOUT_FLOW: `${storeName}.IS_CHECKOUT_FLOW`,
    GUEST_USER_ATTEMPTED_PROFILE: `${storeName}.GUEST_USER_ATTEMPTED_PROFILE`,
    TOGGLE_SHOW_SUCCESS_MSG: `${storeName}.TOGGLE_SHOW_SUCCESS_MSG`,
    EDIT_CHECKOUT_FLOW: `${storeName}.EDIT_CHECKOUT_FLOW`,
    USE_AS_POPUP: `${storeName}.USE_AS_POPUP`,
    UPDATE_PHONE_POPUP_ENABLED: `${storeName}.UPDATE_PHONE_POPUP_ENABLED`,
});

export default getTypes;
